// Maria, 19 October 2026: two top-level filters have new names on screen: 'STAFF' for EMPLOYEES and 'ADMITTED APPLICANTS'
// for FUTURE-ADMISSION. Only the words shown change; the groups keep their stored names, so forms, reports and settings
// linked to them are unaffected. Only the two headings at the top of the tree are renamed, never a school's own group
// with the same name.
const SHOWN_AS = {
    EMPLOYEES: 'STAFF',
    'FUTURE-ADMISSION': 'ADMITTED APPLICANTS'
};

const groupDisplayName = (name, topLevel) => (topLevel ? SHOWN_AS[name] ?? name : name);

export default groupDisplayName;
